import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import popup from "../../../assets/images/settings/Coindh-popup.png";
import { IoIosCloseCircle } from "react-icons/io";
import { Link } from 'react-router-dom';

const Popup = () => {
  const navigate = useNavigate();

  const [popupOpen, setPopupOpen] = useState(false);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setPopupOpen(true);
  //   }, 3000);
  //   return () => clearTimeout(timer);
  // }, []);

  return (
    <div className={popupOpen ? "d-block" : "d-none"}>
      <div className="disclaimer">
        <div className="disclaimer-pos">
          <img src={popup} onClick={() => navigate("/register")} />
          <div className="close-icon" onClick={() => setPopupOpen(!popupOpen)}>
            <IoIosCloseCircle />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
